<template>
  <div class="free-token-modal" v-if="show">
    <div class="modal-content free-token-modal-content">
      <div class="modal-header">
        <button class="back-btn" @click="closeModal"><svg t="1747387769340" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4602" width="200" height="200"><path d="M374.2208 515.9424L774.912 115.2512a56.448 56.448 0 1 0-79.8464-79.8464L255.8976 474.5984c-22.016 22.016-22.016 57.7792 0 79.8208 1.7408 1.7408 3.712 3.1232 5.632 4.608 0.3072 0.3328 0.5632 0.768 0.896 1.1008l428.8768 428.8768a55.1168 55.1168 0 1 0 77.952-77.952L374.2208 515.9424z" fill="#F8B62D" p-id="4603"></path></svg> <span>返回</span></button>
        <!-- <h3>免费获取API调用次数</h3> -->
      </div>
      <div class="modal-body">
        <div class="free-token-info">

          <div class="info-content">

            <p class="free-token-tip">每当次数低于20,关注公众号 <strong class="blue-text">未耕之地</strong> 然后回复 <strong class="yellow-text">次数不够了</strong>将自动获取 200 次调用次数（每3小时限一次）</p>
            
            <div class="qrcode-container">
              <img src="公众号二维码.jpg" alt="公众号二维码" class="wechat-qrcode">
            </div>
            <p class="qrcode-caption">扫码关注公众号</p>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'FreeTokenModal',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    closeModal() {
      this.$emit('close');
    }
  }
}
</script>

<style scoped>
.free-token-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.blue-text {
  color: #58adf8;
}

.yellow-text {
  color: #fbb11c;
}

.free-token-modal-content {
  width: 500px;
  max-width: 90%;
  background-color: white;
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* padding: 15px 20px; */
  /* border-bottom: 1px solid #eee; */
}

.modal-header h3 {
  margin: 0;
  color: #333;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #999;
}

.close-btn:hover {
  color: #333;
}

.modal-body {
  padding: 20px;
}

.free-token-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.info-icon {
  margin-bottom: 20px;
}

.info-content {
  width: 100%;
}

.info-content h4 {
  margin-bottom: 20px;
  color: #333;
  font-size: 18px;
}

.free-token-tip {
  font-size: 16px;
  line-height: 1.6;
  color: #555;
  margin-bottom: 20px;
  padding: 15px;
  background-color: #fff5d3;
  border-radius: 8px;
  border: 1px solid #ffc445;
  /* border-left: 4px solid #F8B62D; */
}

.qrcode-container {
  display: flex;
  justify-content: center;
  margin: 20px 0;
}

.wechat-qrcode {
  width: 200px;
  height: 200px;
  object-fit: contain;
  border: 1px solid #eee;
  border-radius: 4px;
}

.qrcode-caption {
  font-size: 14px;
  color: #666;
  margin-top: 10px;
}

.modal-footer {
  padding: 15px 20px;
  text-align: center;
  border-top: 1px solid #eee;
}

.btn {
  padding: 8px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  border: none;
  transition: all 0.3s;
}

.btn-primary {
  background-color: #F8B62D;
  color: white;
}

.btn-primary:hover {
  background-color: #e5a012;
}

@media (max-width: 768px)  {
  .free-token-modal-content{
    margin-left: 10px;
    margin-right: 10px;
  }
  
}
</style>